module.exports = __webpack_public_path__ + "assets/GTAmerica-ExtendedRegular.woff2";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/fonts/GTAmerica-ExtendedRegular.woff2
// module id = 1013
// module chunks = 19